'use client';

import React, { Fragment } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import classNames from 'classnames';
import CloudSyncStatus from './CloudSyncStatus';

const NAV_ITEMS = [
  { href: '/home', label: 'Home', icon: 'home' },
  { href: '/', label: 'Editor', icon: 'edit_note' },
  { href: '/notes', label: 'Notes', icon: 'notes' },
  { href: '/notebooks', label: 'Notebooks', icon: 'auto_stories' },
  { href: '/areas', label: 'Areas', icon: 'dashboard' },
  { href: '/settings', label: 'Settings', icon: 'settings' },
];

const AppNavigation = ({ isExpanded, onToggle, isVisible }) => {
  const pathname = usePathname();

  if (!isVisible) {
    return null;
  }

  const isActive = (path) => {
    if (path === '/') return pathname === '/';
    return pathname?.startsWith(path);
  };

  return (
    <Fragment>
      <nav
        className={classNames('app-nav', {
          'app-nav--expanded': isExpanded,
          'app-nav--collapsed': !isExpanded,
        })}
        aria-label="App navigation"
      >
        <button
          type="button"
          className="app-nav__toggle"
          onClick={onToggle}
          aria-expanded={isExpanded}
          aria-label={isExpanded ? 'Collapse navigation' : 'Expand navigation'}
        >
          <i className="material-icons" aria-hidden>menu</i>
          <span className="app-nav__title">Drynotes</span>
        </button>
        <div className="app-nav__links">
          {NAV_ITEMS.map((item) => (
            <Link
              key={item.href}
              href={item.href}
              className={classNames('app-nav__link', {
                'app-nav__link--selected': isActive(item.href),
              })}
              title={item.label}
            >
              <i className="material-icons app-nav__icon" aria-hidden>
                {item.icon}
              </i>
              <span className="app-nav__label">{item.label}</span>
            </Link>
          ))}
        </div>
        <div className="app-nav__footer">
          <a href="mailto:amaxwell01@gmail.com" className="app-nav__footer-link" title="Contact Us">
            <i className="material-icons" aria-hidden>help_outline</i>
            <span>Help</span>
          </a>
        </div>
      </nav>
      <div className="desktop-sync-bar">
        <CloudSyncStatus />
      </div>
    </Fragment>
  );
};

export default AppNavigation;
